module.exports = __webpack_public_path__ + "img/icon-4.6c06f004.png";